import { render } from "./login-component.vue?vue&type=template&id=5554ffa8"
import script from "./login-component.vue?vue&type=script&lang=js"
export * from "./login-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__